/* import __COLOCATED_TEMPLATE__ from './icon-anchor.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();